/**
 * Copy for the Auto-dim card (same browser-language mechanism as screenScheduleStrings).
 * The trigger-picker copy (clock time / prayer / offset / prayer names) is shared with it.
 */
import { screenScheduleStrings } from './screenScheduleStrings';

const STRINGS = {
  en: {
    title: 'Auto-dim',
    toggle: 'Auto-dim at night',
    subtitleOn: 'Dims to {dim}% from {from} until {until}',
    dimLevel: 'Dim level',
    dayLevel: 'Day level',
    dimAt: 'Dim at',
    restoreAt: 'Restore at',
    footer: 'The clock lowers its brightness on a schedule and restores it in the morning. The adhan is not affected.',
    saved: 'Auto-dim saved',
  },
  nl: {
    title: 'Automatisch dimmen',
    toggle: "Automatisch dimmen 's nachts",
    subtitleOn: 'Dimt naar {dim}% van {from} tot {until}',
    dimLevel: 'Gedimd niveau',
    dayLevel: 'Dagniveau',
    dimAt: 'Dimmen om',
    restoreAt: 'Herstellen om',
    footer: "De klok verlaagt volgens schema de helderheid en zet die 's ochtends terug. De adhan wordt niet beïnvloed.",
    saved: 'Automatisch dimmen opgeslagen',
  },
  fr: {
    title: 'Atténuation auto',
    toggle: 'Atténuer automatiquement la nuit',
    subtitleOn: "Atténue à {dim} % de {from} jusqu'à {until}",
    dimLevel: 'Luminosité de nuit',
    dayLevel: 'Luminosité de jour',
    dimAt: 'Atténuer à',
    restoreAt: 'Rétablir à',
    footer: "L'horloge baisse sa luminosité selon un programme et la rétablit le matin. L'adhan n'est pas concerné.",
    saved: 'Atténuation automatique enregistrée',
  },
  es: {
    title: 'Atenuación automática',
    toggle: 'Atenuar automáticamente por la noche',
    subtitleOn: 'Atenúa al {dim} % desde {from} hasta {until}',
    dimLevel: 'Brillo nocturno',
    dayLevel: 'Brillo diurno',
    dimAt: 'Atenuar a las',
    restoreAt: 'Restablecer a las',
    footer: 'El reloj baja el brillo según un horario y lo restablece por la mañana. El adhan no se ve afectado.',
    saved: 'Atenuación automática guardada',
  },
  ar: {
    title: 'التعتيم التلقائي',
    toggle: 'تعتيم تلقائي ليلاً',
    subtitleOn: 'يخفّض السطوع إلى {dim}% من {from} حتى {until}',
    dimLevel: 'مستوى التعتيم',
    dayLevel: 'مستوى النهار',
    dimAt: 'التعتيم عند',
    restoreAt: 'الاستعادة عند',
    footer: 'تخفّض الساعة سطوعها حسب الجدول وتعيده في الصباح. لا يتأثر الأذان بذلك.',
    saved: 'تم حفظ التعتيم التلقائي',
  },
  tr: {
    title: 'Otomatik Kısma',
    toggle: 'Geceleri otomatik kısma',
    subtitleOn: '{from} ile {until} arası %{dim} seviyesine kısılır',
    dimLevel: 'Kısık parlaklık',
    dayLevel: 'Gündüz parlaklığı',
    dimAt: 'Kısma zamanı',
    restoreAt: 'Geri dönüş zamanı',
    footer: 'Saat, parlaklığı zamanlamaya göre düşürür ve sabah eski haline getirir. Ezan bundan etkilenmez.',
    saved: 'Otomatik kısma kaydedildi',
  },
  de: {
    title: 'Automatisch dimmen',
    toggle: 'Nachts automatisch dimmen',
    subtitleOn: 'Dimmt von {from} bis {until} auf {dim} %',
    dimLevel: 'Gedimmte Helligkeit',
    dayLevel: 'Helligkeit am Tag',
    dimAt: 'Wann dimmen',
    restoreAt: 'Wann wieder heller',
    footer: 'Die Uhr senkt ihre Helligkeit nach Zeitplan und stellt sie morgens wieder her. Der Adhan ist davon nicht betroffen.',
    saved: 'Automatisches Dimmen gespeichert',
  },
};

export const NIGHT_BRIGHTNESS_LANGUAGES = Object.keys(STRINGS);

export const nightBrightnessStrings = (language) => {
  const lang = typeof language === 'string' ? language.slice(0, 2).toLowerCase() : 'en';
  const shared = screenScheduleStrings(lang);
  return {
    ...(STRINGS[lang] || STRINGS.en),
    off: shared.off,
    clockTime: shared.clockTime,
    prayerTime: shared.prayerTime,
    offset: shared.offset,
    minutes: shared.minutes,
    prayers: shared.prayers,
  };
};

/** "Dims to {dim}% from {from} until {until}" with the values filled in. */
export const formatTemplate = (template, values) =>
  template.replace(/\{(\w+)\}/g, (m, k) => (k in values ? String(values[k]) : m));
